import { fetchWithAuth, parseJsonResponse } from './api'

export interface AlertAcknowledgement {
  username: string
  created_at: number
}

export interface AlertReviewNote extends AlertAcknowledgement {
  id: number
  note: string
}

export interface ReviewedAlert {
  id: string
  symbol: string
  kind: string
  text: string
  occurred_at: number
  owner_username: string | null
  acknowledged: boolean
  has_note: boolean
  outstanding: boolean
  acknowledgements: AlertAcknowledgement[]
  notes: AlertReviewNote[]
}

export interface AlertReviewsResponse {
  alerts: ReviewedAlert[]
  total: number
  last_report_at: number | null
}

export interface AlertReviewFilters {
  pendingOnly: boolean
  symbol: string
  offset: number
  limit: number
}

async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const response = await fetchWithAuth(url, options)
  const data = await parseJsonResponse<T & { detail?: unknown }>(response)
  if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not load or save the alert review. Please try again.')
  return data
}

export function getAlertReviews(filters: AlertReviewFilters): Promise<AlertReviewsResponse> {
  const query = new URLSearchParams({
    pending_only: String(filters.pendingOnly),
    offset: String(filters.offset),
    limit: String(filters.limit),
  })
  if (filters.symbol.trim()) query.set('symbol', filters.symbol.trim())
  return request(`/api/alert-reviews?${query}`, { cache: 'no-store' })
}

export function getAlertReview(id: string): Promise<{ alert: ReviewedAlert }> {
  return request(`/api/alert-reviews/${encodeURIComponent(id)}`, { cache: 'no-store' })
}

export function saveAlertReview(id: string, note: string, acknowledged: boolean): Promise<{ alert: ReviewedAlert }> {
  return request(`/api/alert-reviews/${encodeURIComponent(id)}`, {
    method: 'POST', body: JSON.stringify({ note, acknowledged }),
  })
}
